import { useState } from "react";
import SaleList from "./SaleList";
import Tabs from "../../../../elements/Tabs";
import { Link, useOutletContext } from "react-router-dom";
import SaleExportsList from "./SaleExportList";
import { t } from "i18next";

// Main Sales Component
const SaleManage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [groupBy, setGroupBy] = useState("event");
  const { event, selectedLanguage } = useOutletContext();

  // Tab items configuration
  const tabs = [
    {
      label: t("Summary"),
      content: <SaleList />,
    },
    {
      label: t("Exports"),
      content: <SaleExportsList />,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white px-3 md:px-6 pt-6 pb-0">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <Link
              to={`/${selectedLanguage}/user/myEvent/report/${event?.data?.uid}`}
            >
              <div className="flex items-center gap-2 text-gray-600 mb-6 hover:text-blue-600 transition-colors">
                <i className="fas fa-chevron-left text-sm"></i>
                <span className="text-sm font-medium">
                  {t("Event Reports")}
                </span>
              </div>
            </Link>

            <div className="flex items-start justify-between mb-6">
              <div>
                <h1
                  className="text-2xl md:text-5xl font-bold text-gray-900 mb-3"
                  style={{ color: "#2D1B69" }}
                >
                  {t("Sales Summary")}
                </h1>
              </div>
            </div>
          </div>

          {/* Custom Tabs Design */}
          <Tabs
            items={tabs}
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
            contentClass={"p-0 md:p-auto"}
          />
        </div>
      </div>
    </div>
  );
};

export default SaleManage;
